<template>
    <div>
        <editor-content v-if='editor' class="form-control border-input editor" :editor="editor" />
    </div>
</template>

<script>
import { Editor, EditorContent } from 'tiptap'

export default {

  props: {
    value: {
      type: String
    }
  },

  components: {
    EditorContent
  },

  data () {
    return {
      editor: undefined,
      content: undefined
    }
  },

  watch: {
    value (depois, antes) {
      if (antes === null && depois !== null) {
        this.updateContent()
      }
    }
  },

  mounted () {
    this.updateContent()
  },

  methods: {
    updateContent () {
      try {
        this.content = JSON.parse(this.value)
      } catch (error) {
        this.content = {
          type: 'doc',
          content: [{
            type: 'paragraph',
            content: [
              {
                type: 'text',
                text: this.value
              }
            ]
          }]
        }

        if (!this.value) {
          this.content.content[0].content = []
        }
      }

      if (!this.editor) {
        this.createEditor()
      } else {
        this.editor.setContent(this.content, true)
      }
    },

    createEditor () {
      this.editor = new Editor({
        content: this.content,
        onUpdate: ({ getJSON }) => {
          this.content = getJSON()
          this.$emit('input', JSON.stringify(this.content))
        }
      })
    }
  },

  beforeDestroy () {
    if (this.editor) {
      this.editor.destroy()
    }
  }

}
</script>
<style scoped>
    .editor {
        height: initial;
    }

    .editor >>> .ProseMirror {
        outline: none;
    }
</style>
